export default __webpack_public_path__ + "images/combochart.dc099dc041eb913a0035547ca2f51bed.svg";